import React from 'react'
import { Button, Spacer, Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { UrlIcon } from 'assets/icons'
import ActionListItemRow from 'src/components/Settings/ActionListItemRow'

const UrlActionListItemRow = ({ globalUrl, editUrl, entityName, slugUrl }) => (
   <ActionListItemRow
      name={`${entityName} URL`}
      description={(
         <View width="100%">
            {`This ${entityName} is accessible at:`}
            <Spacer size="2" />
            <View
               width="100%"
               padding="9px 12px"
               backgroundColor="#edf3f5"
               borderRadius="4px"
               style={{ overflowX: 'auto' }}>
               <Text size="1.5" color="#576874">
                  {slugUrl}
               </Text>
               {globalUrl && (
                  <View
                     width="100%"
                     marginTop="6px"
                     paddingTop="6px"
                     borderTop="1px solid rgba(87, 104, 116, 0.2)">
                     <Text size="1.5" color="#576874">
                        {`/${globalUrl}`}
                     </Text>
                  </View>
               )}
            </View>
         </View>
      )}
      action={(
         <Button
            linkTo={editUrl}
            width="78px"
            size="xs"
            name="Edit"
            color="#eee"
            textColor="#222"
         />
      )}
      icon={(
         <UrlIcon
            width="18px"
            height="18px"
            strokeWidth="2px"
            color="#aaa"
         />
      )}
   />
)

UrlActionListItemRow.propTypes = {
   globalUrl: PropTypes.string,
   editUrl: PropTypes.string.isRequired,
   entityName: PropTypes.string.isRequired,
   slugUrl: PropTypes.string.isRequired
}

UrlActionListItemRow.defaultProps = {
   globalUrl: undefined
}

export default UrlActionListItemRow
